import React from 'react';
import styled from 'styled-components';
import { useHistory, useParams } from "react-router-dom";
import renderIf from 'render-if';

import Page from "../layout/Page";
import PageHeader from "../components/PageHeader";
import YMMTForm from "../components/YMMTForm";
import YMMTFormSkeleton from '../components/YMMTFormSkeleton';
import useTradeInState from '../hooks/useTradeInState'
import useVIN from '../hooks/useVIN';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 100px 100px;
`;

function Header() {
  const { accountId } = useParams();
  return (
    <PageHeader
      title="What type of vehicle are you interested in purchasing?"
      subtitle="Could be in the next day or in a few months."
      link={`/${accountId}`}
    />);
}

export default function InterestedVehicle ({ children }) {
  const [{ interestedVehicle } , update] = useTradeInState();
  const history = useHistory();
  const [{ loading, error, loaded, ...initYMMT }] = useVIN(interestedVehicle.vin);

  const handleNext = ({ ymmtIds }) => {
    update('interestedVehicle', ymmtIds);
    history.push('contact');
  };

  const showLoading = interestedVehicle.vin && loading;

  return (
    <Page header={<Header/>} footer={children}>
      <Wrapper>
        {renderIf(showLoading)(<YMMTFormSkeleton />)}
        {renderIf(!showLoading)(<YMMTForm initialYMMT={initYMMT} onSubmit={handleNext} trimOptional action="Next" />)}
      </Wrapper>
    </Page>
  );
}
